import { Stack } from '@mui/material';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/free-mode';
import { Autoplay, FreeMode } from 'swiper/modules';
import { SwiperSlide } from 'swiper/react';
import ItemCarouselControls from './item-carousel-controls/item-carousel-controls.component';
import * as S from './item-carousel.styles';

const ItemCarousel = ({ items, renderItem }) => {
  return (
    <Stack direction="column" spacing={1}>
      <S.ItemSwiper
        modules={[Autoplay, FreeMode]}
        slidesPerView="auto"
        spaceBetween={15}
        loop={true}
        loopedSlides={items.length}
        autoplay={{
          delay: 3000,
          pauseOnMouseEnter: true,
        }}
        freeMode={{
          enabled: true,
          momentumBounce: false,
          momentumRatio: 0.5,
          momentumVelocityRatio: 0.5,
        }}
      >
        {items.map(item => (
          <SwiperSlide key={item.item.itemId}>{renderItem(item)}</SwiperSlide>
        ))}
        <ItemCarouselControls />
      </S.ItemSwiper>
    </Stack>
  );
};

export default ItemCarousel;
